import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import "./hero.css"

const Hero = () => {
  const history = useHistory()
  const [location, setLocation] = useState("")
  const [propertyType, setPropertyType] = useState("")
  const [priceRange, setPriceRange] = useState("")

  const handleSubmit = (e) => {
    e.preventDefault()
    const params = new URLSearchParams()
    if (location.trim()) params.set("location", location.trim())
    if (propertyType.trim()) params.set("type", propertyType.trim())
    const priceStr = priceRange.trim().replace(/[^\d\s-]/g, "")
    const num = priceStr ? parseInt(priceStr, 10) : null
    if (num != null && !Number.isNaN(num)) params.set("priceMin", String(num))
    const query = params.toString()
    history.push(query ? `/listings?${query}` : "/listings")
  }

  return (
    <section className='hero'>
      <video
        className='hero__video'
        autoPlay
        muted
        loop
        playsInline
        poster='/images/banner.png'
        aria-hidden='true'
      >
        <source
          src='images/hero/specialgardens.mp4'
          type='video/mp4'
        />
      </video>
      <div className='hero__overlay' />

      <div className='container hero__content'>
        <div className='hero__copy'>
          <span className='hero__eyebrow'>Vista Hill Houses</span>
          <h1>Modern homes, curated listings, and custom builds in Ghana.</h1>
          <p>
            Discover move-in-ready properties, explore premium home options, or start a
            design and build journey shaped around how you want to live.
          </p>
          <div className='hero__actions'>
            <Link to='/listings' className='hero__primary'>
              Explore listings
            </Link>
            <Link to='/contact' className='hero__secondary'>
              Book a tour
            </Link>
          </div>
        </div>

        <div className='hero__panel'>
          <div className='hero__panel-top'>
            <span>Search available homes</span>
            {/* <strong>Find your fit</strong> */}
          </div>
          <form className='hero__search' onSubmit={handleSubmit}>
            <div className='box'>
              <span>City / Area</span>
              <input
                type='text'
                placeholder='East Legon, Airport, Oyarifa'
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                aria-label='City or area'
              />
            </div>
            <div className='box'>
              <span>Property Type</span>
              <input
                type='text'
                placeholder='House, villa, apartment'
                value={propertyType}
                onChange={(e) => setPropertyType(e.target.value)}
                aria-label='Property type'
              />
            </div>
            <div className='box'>
              <span>Price Range</span>
              <input
                type='text'
                placeholder='Your budget'
                value={priceRange}
                onChange={(e) => setPriceRange(e.target.value)}
                aria-label='Price range'
              />
            </div>
            <button type='submit' className='btn1'>
              <i className='fa fa-search'></i> Search
            </button>
          </form>
          <div className='hero__stats' aria-label='Company highlights'>
            <span>
              <strong>15+</strong>
              Years
            </span>
            <span>
              <strong>500+</strong>
              Builds
            </span>
            <span>
              <strong>8K+</strong>
              Clients
            </span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
